import type { PropsWithChildren } from 'react';
import { Sidebar } from '../navigation/Sidebar';
import type { Profile } from '../../types/profile';

export function HelpLayout({ profile, children }: PropsWithChildren<{ profile: Profile }>) {
  return (
    <div className="help-layout page-shell">
      <div className="desktop-sidebar"><Sidebar profile={profile} /></div>
      <details className="mobile-sidebar">
        <summary>Menu desta área</summary>
        <Sidebar profile={profile} />
      </details>
      <main className="help-main">{children}</main>
    </div>
  );
}
